import { LoaderFunction, redirect } from "react-router-dom";
import HttpService from "@core/services/http/http.service";
import { PathnameUrl } from "@app/constants";

export const isAuthenticated: LoaderFunction = async ({ request }) => {
  const token = HttpService.getAccessToken();

  if (request.url.includes("/login")) {
    if (token) {
      return redirect(PathnameUrl.DEVICE_MANAGEMENT);
    }
  } else {
    if (!token) {
      return redirect("/login");
    }
  }

  return null;
};
